/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/share_ios_medium'
export default icon
